

export function hasAccess(user, routeMeta, inPrivateNet) {
  const permsOk = !routeMeta.permission || routeMeta.permission.some(requiredPerm =>
    user?.pms?.some(userPerm => userPerm.startsWith(requiredPerm))
  );
  const netOk = !routeMeta.requirePrivateNet || inPrivateNet;
  return permsOk && netOk;
}
